import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { InsightsSection } from '../components/InsightsSection';
import { HomeIcon } from 'lucide-react';
export function DomesticInvestigations() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-420">
      <Header data-id="element-421" />

      {/* Banner Section */}
      <section className="relative w-full h-[400px] bg-gradient-to-br from-kgi-blue-900 to-kgi-blue-800 overflow-hidden mt-20" data-id="element-422">
        <div className="absolute inset-0 bg-black opacity-20" data-id="element-423"></div>
        <div className="relative container mx-auto px-4 h-full flex items-center justify-center" data-id="element-424">
          <div className="text-center" data-id="element-425">
            <HomeIcon className="h-20 w-20 text-white mx-auto mb-6 drop-shadow-lg" data-id="element-426" />
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg" data-id="element-427">
              Domestic Investigations
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto drop-shadow" data-id="element-428">
              Sensitive, confidential investigations for personal matters
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-429">
        <div className="container mx-auto px-4" data-id="element-430">
          <div className="max-w-4xl mx-auto" data-id="element-431">
            <div className="prose prose-lg max-w-none mb-12" data-id="element-432">
              <p className="text-xl text-gray-700 leading-relaxed mb-6" data-id="element-433">
                Domestic investigations require sensitivity, discretion, and
                professionalism. At Koda Group Inc., we understand that personal
                matters are often emotionally charged and require careful
                handling. Our experienced investigators provide the evidence you
                need for divorce proceedings, custody disputes, and other
                domestic cases while maintaining the highest standards of
                confidentiality and ethical conduct.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-434">
                Whether you need surveillance to document infidelity, asset
                searches for divorce proceedings, or background checks on new
                partners, we handle each case with compassion and
                professionalism. Our investigators use state-of-the-art
                surveillance equipment and proven investigative techniques to
                gather admissible evidence that can support your case in court.
                We provide detailed reports and documentation that meet legal
                standards.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-435">
                Our domestic investigation services include infidelity and
                adultery investigations, cohabitation verification, asset
                searches and hidden asset discovery, lifestyle investigations,
                background checks on romantic partners, prenuptial and
                postnuptial investigation support, and surveillance operations.
                We work closely with family law attorneys to provide the
                evidence needed for successful case outcomes.
              </p>
            </div>

            <div className="text-center bg-gray-50 rounded-lg p-8" data-id="element-436">
              <h3 className="font-serif text-2xl font-bold text-kgi-blue-900 mb-4" data-id="element-437">
                Get the Answers You Need
              </h3>
              <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-438">
                Contact us for a confidential consultation about your domestic
                investigation needs.
              </p>
              <a href="/contact-koda-private-investigators.html" className="inline-flex items-center bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-xl text-lg" data-id="element-439">
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </section>

      <InsightsSection data-id="element-440" />
      <Footer data-id="element-441" />
    </div>;
}